<!--
    @TODO HL-17645 research on how to prevent interference between mouseover and touchstart
    both events fires on mobile
    @source https://developer.apple.com/library/archive/documentation/AppleApplications/Reference/SafariWebContent/HandlingEvents/HandlingEvents.html
-->
<div
  class="tooltip"
  (mouseover)="viewTooltip($event)"
  (mouseout)="hideTooltip()"
  (touchstart)="toggleTooltip($event)"
  [ngClass]="{
    'tooltip--label': hasLabel,
    'tooltip--disabled': isDisabled,
    'tooltip--is-open': showTooltip,
    'tooltip--readonly': isReadonly
  }"
  #tooltipRef
>
  <div class="tooltip__pointer-overlay"></div>
  <span [ngClass]="getClasses()" [style.transform]="transform" #tooltipOverlay>
    {{ helpText }}
    <ng-content select="[tip]"></ng-content>
  </span>
  <div [hidden]="!hasLabel">
    <ng-content select="[label]"></ng-content>
  </div>
</div>
